import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';
import FontIcon from 'material-ui/FontIcon';
import RaisedButton from 'material-ui/RaisedButton';
import pallet from 'constants/colors';

const styles = {
  root: {
    marginTop: 16,
    marginBottom: 16,
  },
  icon: {
    marginRight: 8,
  },
  panel: {
    padding: 16,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  panelText: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
  },
  message: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
  },
  info: {
    borderLeft: `solid 4px ${pallet.infoColor}`,
  },
  success: {
    borderLeft: `solid 4px ${pallet.successColor}`,
  },
  warning: {
    borderLeft: `solid 4px ${pallet.warningColor}`,
  },
  error: {
    borderLeft: `solid 4px ${pallet.errorColor}`,
  },
  actionStyle: {
    alignSelf: 'flex-end',
  },
};

const color = {
  info: pallet.infoColor,
  success: pallet.successColor,
  warning: pallet.warningColor,
  error: pallet.errorColor,
  default: '#555',
};

const PanelMessage = ({
  message,
  iconName,
  iconClassName,
  type,
  action,
  actionLabel,
  zDepth,
}) => (
  <Col xs style={styles.root}>
    <Paper zDepth={zDepth} style={{ ...styles.panel, ...styles[type] }} >
      <div style={styles.panelText}>
        <FontIcon style={styles.icon} color={color[type]} className={iconClassName}>{iconName}</FontIcon>
        <span style={styles.message}>{message}</span>
      </div>
      {action && actionLabel &&
      <RaisedButton
        style={styles.actionStyle}
        backgroundColor={color[type]}
        labelColor="#fff"
        onClick={action}
        label={actionLabel}
      />
      }
    </Paper>
  </Col>
);

PanelMessage.propTypes = {
  /*
    The message to be displayed inside the component
  */
  message: PropTypes.node,

  /*
    Then name of the icon placed inside the icon component
  */
  iconName: PropTypes.string,

  /*
    The class name of the icon component
  */
  iconClassName: PropTypes.string,

  /*
    The style type of the component
  */
  type: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'default']),
  /*
    The function to trigger on the action click
  */
  action: PropTypes.func,
  /*
    The label for the action button
  */
  actionLabel: PropTypes.node,
  /*
    The shadow depth of the paper component
  */
  zDepth: PropTypes.number,
};

PanelMessage.defaultProps = {
  type: 'default',
  iconClassName: 'material-icons',
  zDepth: 0,
};

export default PanelMessage;



// WEBPACK FOOTER //
// ./src/components/panels/PanelMessage.js